﻿import React, { useMemo } from 'react';
import { Headline_Props, Text_Props } from '@Util/Types';
import { str_isEmpty } from '@Util/Utils';

function generateClassName(baseClass: string, props: { className?: string, center?: boolean, bold?: boolean, secondary?: boolean, small?: boolean }): string {
    let classStr = baseClass;

    if (!str_isEmpty(props.className)) {
        classStr += ` ${props.className}`;
    }

    if (props.center) {
        classStr += ` ${baseClass}--Centered`;
    }

    if (props.bold) {
        classStr += ` ${baseClass}--Bold`;
    }

    if (props.secondary) {
        classStr += ` ${baseClass}--Secondary`;
    }

    if (props.small) {
        classStr += ` ${baseClass}--Small`;
    }

    return classStr;
}

export function H1(props: Headline_Props): JSX.Element {
    const className = useMemo(() => generateClassName("Headline1", props), [props]);

    return <h1 className={className}>{props.children}</h1>;
}

export function H2(props: Headline_Props): JSX.Element {
    const className = useMemo(() => generateClassName("Headline2", props), [props]);

    return <h2 className={className}>{props.children}</h2>;
}

export function H3(props: Headline_Props): JSX.Element {
    const className = useMemo(() => generateClassName("Headline3", props), [props]);

    return <h3 className={className}>{props.children}</h3>;
}

export function P(props: Text_Props): JSX.Element {
    const className = useMemo(() => generateClassName("Normal", props), [props]);

    return <p className={className}>{props.children}</p>;
}